import APIClient from 'App/api_client';

type Source =
  | 'network'
  | 'pause'
  | 'play'
  | 'rewind'
  | 'fast_forward'
  | 'speed'
  | 'jump'
  | 'console'
  | 'stack_events'
  | 'storage'
  | 'profiler'
  | 'performance'
  | 'graphql'
  | 'fetch'
  | 'exceptions'
  | 'longtasks'
  | 'inspector'
  | 'xray'
  | 'replay'
  | 'return'
  | 'duration'
  | 'share'
  | 'notes'
  | 'vault'
  | 'understand_network'
  | 'understand_console';

export interface SignalV2 {
  /** FOSS callers also send composed sources (`xray_<feature>`, devtools tab names) */
  source: Source | (string & {});
  value?: any;
}
export default class SignalService {
  private client: APIClient;

  constructor(client?: APIClient) {
    this.client = client ? client : new APIClient();
  }

  initClient(client?: APIClient) {
    this.client = client || new APIClient();
  }

  send(signal: SignalV2, sessionId: string): Promise<any> {
    const projectId = parseInt(window.location.pathname.split('/')[1]);
    return this.client
      .post(`/${projectId}/${sessionId}/signals`, signal)
      .then((r) => {
        return r.json().then((j) => j.data);
      });
  }
}
